import React from 'react';
import { Form, Input, Row, Col, Button , Upload, Select, Icon } from 'antd';
import { uploadSlider} from '../../modules/Api';
import {END_POINT} from '../../constants/config';

const FormItem = Form.Item;
const Option = Select.Option;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class SliderForm extends React.Component {
    constructor() {
        super();

        let httpVars = window.location.search
            .replace('?', '')
            .split('&')
            .reduce((params, q) => {
                const [key, value] = q.split('=');
                params[key] = value;
                return params;
            }, {});

            this.state = {
                link:false,
                photo:null,
                type: 0,
                alt: '',
                slider_type : null,
            }

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.initialData.photo_link && this.state.photo === null) {
            this.setState({photo: nextProps.initialData.photo_link});
        }
    }

    typeChange = value => {
        this.setState({type:value});
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {photo: this.state.photo}));
        });
    }

    get appSlider() {
        return this.props.appSlider;
    }

    renderSelect() {
        if (this.appSlider) {
            return (
                <Select defaultValue="2" style={{ width: 120 }} onChange={this.typeChange}>
                    <Option value="2">کوپن</Option>
                    <Option value="3">برند</Option>
                </Select>
            )
        } else {
            return (
                <Select defaultValue="0" style={{ width: 120 }} onChange={this.typeChange}>
                    <Option value="0">موبایل</Option>
                    <Option value="1">دسکتاپ</Option>
                    <Option value="4">تک</Option>
                    <Option value="6">اپ موبایل با لینک خارجی</Option>
                </Select>
            )
        }
    }

    render() {
        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;

        return (
            <div style={{direction: 'rtl'}}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={20} offset={2}>

                        {
                            !this.appSlider &&
                            <FormItem
                            {...formItemLayout}
                            label="لینک"
                            style={{direction:'ltr'}}
                            colon={false}>
                                {getFieldDecorator('link', {
                                    initialValue: this.props.initialData.link,
                                    rules: [
                                    { required: true, message: 'این قسمت الزامی است.' },
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        }

                        <FormItem
                        {...formItemLayout}
                        label="نوع"
                        colon={false}>
                            {getFieldDecorator('type', {
                                initialValue: this.props.initialData.type,
                                rules: [
                                { required: true, message: 'این قسمت الزامی است.' },
                                ],
                            })(
                                this.renderSelect()
                            )}
                        </FormItem>

                        {
                            !this.appSlider &&
                            <FormItem
                            {...formItemLayout}
                            label="Alt"
                            colon={false}>
                                {getFieldDecorator('alt', {
                                    initialValue: this.props.initialData.alt,
                                    rules: [
                                    { required: true, message: 'این قسمت الزامی است.' },
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        }

                        <FormItem
                        {...formItemLayout}
                        label="عکس"
                        extra="فایل مورد نظر را انتخاب کنید"
                        colon={false}>
                        {getFieldDecorator('photo', {
                            valuePropName: 'fileList',
                            getValueFromEvent: this.normFile,
                            rules: [
                                { required: true, message: 'این قسمت الزامی است.' },
                            ],
                        })(
                            <Upload
                            name="photo_link"
                            action=""
                            customRequest={() => {}}
                            onChange={f => {uploadSlider(f, (src) => {
                                this.setState({photo: src});
                            },this.state.type,this.state.slider_type)}}
                            listType="picture"
                            showUploadList={false}>
                            <Button>
                                <Icon type="upload" /> انتخاب فایل
                            </Button>
                            <br />
                            {
                                this.state.photo != null
                                &&
                                <img src={`${this.state.photo.includes('http') ? this.state.photo : END_POINT + this.state.photo}`}
                                    style={{width: '50px', height: '50px', margin: '10px'}}
                                    alt="اسلایدر"
                                />
                            }
                            </Upload>
                        )}
                        </FormItem>

                        {
                            this.appSlider &&
                            <FormItem
                            {...formItemLayout}
                            label="آیدی رفرنس"
                            colon={false}>
                                {getFieldDecorator('referance_id', {
                                    initialValue: 0,
                                    rules: [
                                        { required: true, message: 'این قسمت الزامی است.' },
                                    ],
                                })(
                                    <Input  type="number" />
                                )}
                            </FormItem>
                        }
                    </Col>
                </Row>
                <Row>
                <Col span={24}>
                    <FormItem>
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            style={{width: '10%', margin: '0px 45%'}}>
{this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                        </Button>
                    </FormItem>
                </Col>
                </Row>
            </Form>
            </div>
        );
    }
}

SliderForm.defaultProps = {
    initialData: {}
}

export default Form.create()(SliderForm);



// WEBPACK FOOTER //
// ./src/containers/Sliders/form.js